/* import __COLOCATED_TEMPLATE__ from './serialnumbertransfer.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();